<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="profiles"
      :server-items-length="totalProfiles"
      :loading="loading"
      :page="page"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="loadTable" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.profiles.name')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.name"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg" elevation="1" color="#41916b" @click="dialog = true, resource = {}">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="dialog = true, resource = item">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadTable()"
            url="profiles"
          />
        </Menu>
      </template>

      <template v-slot:[`item.abilities_count`]="{ item }"> 
        <v-chip
          class="abilities-chip"
          color="#e8f3ee" 
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left small color="#41916b">mdi-shield-key-outline</v-icon>
            <strong>{{ abilitiesCount(item) }}</strong>
            <span class="abilities-total">/{{ totalAbilities }}</span>
        </v-chip> 
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog" width="400px">
      <div class="banner">
        <h4>{{ resource.id ? $t('titles.edit_profile') : $t('titles.new_profile') }}</h4>
      </div>
      <v-card-text>
        <v-form @submit.prevent="saveProfile">
          <v-text-field v-model="resource.name" :label="$t('inputs.profiles.name')" color="#41916b" />
          <v-text-field v-model="resource.slug" :label="$t('inputs.profiles.slug')" color="#41916b" />
          <v-btn color="#41916b" class="rounded-lg" type="submit" dark style="margin-right: 10px;" :loading="loading">
            {{$t('buttons.save')}}
          </v-btn>
          <v-btn color="white" class="rounded-lg" @click="dialog = false, resource = {}">
            {{$t('buttons.cancel')}}
          </v-btn>
        </v-form>
      </v-card-text>
    </Modal>
  </div>
</template>

<script>
import { getAbilities, getProfiles, saveProfile } from "@/service/basic-registrations/ProfileService";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Menu,
    ChangeStatus,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      headers: [
        { text: "Perfil", align: "start", value: "name" },
        { text: "Quantidade de Permissões", align: "center", value: "abilities_count", sortable: false },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      loading: false,
      options: {},
      sortBy: "name",
      profiles: [],
      resource: {},
      totalProfiles: 0,
      totalAbilities: 0,
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
        {
          name: "Permissões",
          type: "page",
          route: "/listar-permissoes",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
    this.loadTable();
    this.loadTotalAbilities();
  },

  watch: {
    options: {
      handler() {
        this.loadTable();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    loadTable() {
      const { page, itemsPerPage } = this.options;
      this.loading = true;
      getProfiles({
        name: this.filterForm.name || '',
        page,
        per_page: itemsPerPage,
      }).then((result) => {
        this.profiles = result.data;
        this.totalProfiles = result.total;
        this.loading = false;
      });
    },

    loadTotalAbilities() {
      getAbilities().then((result) => {
        this.totalAbilities = result.length;
      });
    },

    abilitiesCount(item) {
      return (item.abilities || []).length;
    },

    abilitiesPercent(item) {
      if (!this.totalAbilities) return 0;
      return Math.round((this.abilitiesCount(item) / this.totalAbilities) * 100);
    },

    clearFilter() {
      this.filterForm = {};
      this.loadTable();
    },

    saveProfile() {
      this.loading = true;
      const profile = {
        name: this.resource.name.toUpperCase(),
        slug: this.resource.slug.toUpperCase(),
      };

      saveProfile(this.resource.id || null, profile).then((response) => {
        this.changeSnackBarData({
          status: true,
          type: "success",
          titleMessage: response.data.message,
          bodyMessage: "",
          cardColor: "#41916b",
          titleIcon: "mdi-checkbox-marked-circle",
        });
        this.loading = false;
        this.dialog = false;

        setTimeout(() => {
          if (!this.resource.id) {
            this.$router.push({ path: '/listar-permissoes', query: { item: response.data.id } });
          } else {
            this.loadTable();
            this.resource = {};
          }
          this.changeSnackBarData({ status: false, type: '', titleMessage: '', bodyMessage: '', cardColor: '', titleIcon: '' });
        }, 2000);
      }).catch((err) => {
        this.loading = false;
        this.changeSnackBarData({
          status: true,
          type: "error",
          titleMessage: err.response.data.message,
          bodyMessage: "",
          cardColor: "#41916b",
          titleIcon: "mdi-alert-circle",
        });
        setTimeout(() => {
          this.dialog = false;
          this.changeSnackBarData({ status: false, type: '', titleMessage: '', bodyMessage: '', cardColor: '', titleIcon: '' });
        }, 3000);
      });
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.abilities-chip {
  font-family: "Poppins"; 
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.abilities-chip:hover {
  transform: translateY(-1px);
  background-color: #d4ebe0 !important;
  box-shadow: 0 2px 6px rgba(65, 145, 107, 0.25);
}

.abilities-total {
  opacity: 0.7;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.banner {
  background: #b3ffab; 
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c); 
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd); 

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
